<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><span class="smallcaps">THOMAS DUNNE BOOKS</span>.</p>
<p class="center-para">An imprint of St. Martin’s Press.</p>
<p class="para"> </p>
<p class="center-para"><span class="smallcaps">SEAL WARRIOR</span>. Copyright © 2009 by Thomas H. Keith and J. Terry Riebling.</p>
<p class="center-para">Foreword copyright © by Lt. Michael E. Thornton U.S. Navy (Ret.).</p>
<p class="center-para">All rights reserved. Printed in the United States of America. For information, address</p>
<p class="center-para">St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a></p>
<p class="center-para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="center-para"><em>All photos are courtesy of the Tom Keith collection.</em></p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para">Keith, Thomas H.</p>
<p class="indent-para">    SEAL warrior : death in the dark—Vietnam, 1968–1972 / Thomas H. Keith and J. Terry Riebling ; foreword by Michael E. Thornton.—1st ed.</p>
<p class="indent-para">         p. cm.</p>
<p class="indent-para">    Includes bibliographical references and index.</p>
<p class="indent-para">    ISBN 978-0-312-37904-9</p>
<p class="indent-para">    1. Keith, Thomas H. 2. Vietnam War, 1961–1975—Personal narratives, American. 3. Vietnam War, 1961–1975—Commando operations. 4. United States. Navy. SEALs—Biography. 5. United States. Navy. SEALs—History—20th century. 6. Guerrillas—United States—Biography. 7. Guerrillas—<br/>Vietnam—Biography. 8. Guerrilla warfare—Vietnam—History—20th century. I. Riebling, J. Terry. II. Title.</p>
<p class="indent-para">DS559.5.K395 2009</p>
<p class="indent-para">959.704'38—dc22</p>
<p class="indent-para">[B]</p>
<p class="right-para">2009007825</p>
<p class="para"> </p>
<p class="center-para">First Edition: July 2009</p>
<p class="para"> </p>
<p class="center-para">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?ed6a5246